export default {
  data() {
    return {
      customer_too_new: false,
      customer_slug: window.user?.customer?.slug,
    };
  },
  beforeMount() {
    // Determine if the customer is too new for analytics. i.e. the customer was created this month.
    const customer_created_at = window.user.customer.created_at;
    const moment_created_at = moment(customer_created_at);
    const current_date = moment();
    this.customer_too_new = moment_created_at.isSame(current_date, 'month');
  },
  computed: {
    next_month() {
      const current_date = window.moment();
      const last_month = current_date.add(1, 'months');
      return last_month.format('MMM YYYY');
    },
    data_range() {
      const current_date = window.moment();
      const last_month = current_date.subtract(1, 'months');
      return last_month.format('MMM YYYY');
    },
    radar_base_url() {
      if (!this.customer_slug) {
        return 'https://radar.sharp-stream.com/sharpstream/podcasts';
      } else {
        return `https://radar.sharp-stream.com/sharpstream/podcasts?provider_id=${this.customer_slug}`;
      }
    },
  },
};
